import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { label } from '../../../constants/labels';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public currentYear: number = new Date().getFullYear();
  public lifeOnLogo: string;
  labels: any = label;
  environments: any = environment;
  ngOnInit() {
    this.lifeOnLogo = 'assets/lifeison-schneider.svg';
  }

}
